import {
  baseUniDriverFactory,
  UniDriver,
} from '@wix/wix-ui-test-utils/unidriver';
import { getUniDriverStyle } from '../../test-utils/getUniDriverStyle';

export function NestedTableGhostRowUniDriver(
  base: UniDriver,
  _body: UniDriver,
) {
  return {
    ...baseUniDriverFactory(base),
    getIndentationCellDepth: async () => {
      const width = Number(
        (await getUniDriverStyle(base)).width.split('px')[0],
      );
      const indentationWidth = Number(
        await base.attr('data-indentation-width'),
      );
      const parentCellPaddingStart = Number(
        await base.attr('data-parent-cell-padding-start'),
      );
      const widthWithoutPaddingOrZero = Math.max(
        0,
        width - parentCellPaddingStart,
      );
      return widthWithoutPaddingOrZero / indentationWidth;
    },
  };
}
